module.exports = __webpack_public_path__ + "static/media/0001.5495c012.jpg";